import { render } from "./about.vue?vue&type=template&id=b85a249a&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=b85a249a&lang=scss&scoped=true"

import exportComponent from "/Users/huangli/Desktop/未命名文件夹 2/borun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85a249a"]])

export default __exports__